import request from '@/utils/request'


// 查询直播列表
export function listLive(query) {
  return request({
    url: '/live/live/list',
    method: 'get',
    params: query
  })
}

// 查询直播分页
export function pageLive(query) {
  return request({
    url: '/live/live/page',
    method: 'get',
    params: query
  })
}

// 查询直播详细
export function getLive(data) {
  return request({
    url: '/live/live/detail',
    method: 'get',
    params: data
  })
}
export function getLiveGoods(data) {
  return request({
    url: '/live/live/goodsList',
    method: 'get',
    params: data
  })
}
export function addLiveGoods(data) {
  return request({
    url: '/live/live/addGoodsToLiveRoom',
    method: 'post',
    params: data
  })
}
export function deleteLiveGoods(data) {
  return request({
    url: '/live/live/deleteLiveGoods',
    method: 'get',
    params: data
  })
}

export function shangjia(data) {
  return request({
    url: '/live/live/shangjia',
    method: 'get',
    params: data
  })
}
export function xiajia(data) {
  return request({
    url: '/live/live/xiajia',
    method: 'get',
    params: data
  })
}
export function editLivePrice(data) {
  return request({
    url: '/live/live/editLivePrice',
    method: 'post',
    params: data
  })
}
export function editLiveRecommend(data) {
  return request({
    url: '/live/live/editLiveRecommend',
    method: 'post',
    params: data
  })
}
// 新增直播
export function addLive(data) {
  return request({
    url: '/live/live/add',
    method: 'post',
    data: data
  })
}

// 修改直播
export function updateLive(data) {
  return request({
    url: '/live/live/edit',
    method: 'post',
    data: data
  })
}
// 开启直播
export function startLive(data) {
  return request({
    url: '/live/live/startLive',
    method: 'post',
    data: data
  })
}

// 关闭直播
export function endLive(data) {
  return request({
    url: '/live/live/endLive',
    method: 'post',
    data: data
  })
}
export function shopUserList(data) {
  return request({
    url: '/live/live/shopUserList',
    method: 'get',
    data: data
  })
}

export function userList(data) {
  return request({
    url: '/live/live/userList',
    method: 'get',
    data: data
  })
}
// 删除直播
export function delLive(data) {
  return request({
    url: '/live/live/delete',
    method: 'post',
    data: data
  })
}
